import React from 'react'

export default ({
  msdsSheets
}) => (
  <div className='msds-sheets'>
    {msdsSheets.map(msdsSheet =>
      <a className='msds-sheet' download href={msdsSheet.file.url} style={sheetStyle(msdsSheet)}>
        <p>{msdsSheet.name}</p>
      </a>
    )}
  </div>
)

function sheetStyle (msdsSheet) {
  return {
    backgroundImage: `url(${msdsSheet.file.preview.url})`
  }
}



// WEBPACK FOOTER //
// ./src/components/msds-sheets/msds-sheets-list.js